/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Download_Preparing_MessageInputs */

const en_mobile_download_preparing_message = /** @type {(inputs: Mobile_Download_Preparing_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We're preparing the audio. Large documents can take a while. The download starts on its own as soon as it's ready.`)
};

const es_mobile_download_preparing_message = /** @type {(inputs: Mobile_Download_Preparing_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estamos preparando el audio. Los documentos grandes pueden tardar. La descarga empezará sola en cuanto esté lista.`)
};

/**
* | output |
* | --- |
* | "We're preparing the audio. Large documents can take a while. The download starts on its own as soon as it's ready." |
*
* @param {Mobile_Download_Preparing_MessageInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_download_preparing_message = /** @type {((inputs?: Mobile_Download_Preparing_MessageInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Download_Preparing_MessageInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_download_preparing_message(inputs)
	return en_mobile_download_preparing_message(inputs)
});